import { Moon, CheckCircle2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

// Recepción de Inventario Nocturno al abrir turno — presentacional.
export const RecepcionInventarioDialog = ({ recepcionOpen, setRecepcionOpen, inventarioPatio }) => (
  <Dialog open={recepcionOpen} onOpenChange={setRecepcionOpen}>
    <DialogContent className="rounded-none border-[#6366F1] bg-[#0A0A0A] text-white sm:max-w-md max-h-[90dvh] overflow-y-auto overflow-x-hidden" data-testid="recepcion-inventario-modal">
      <DialogHeader>
        <DialogTitle className="font-display font-black text-white flex items-center gap-2">
          <Moon className="h-5 w-5 text-[#818CF8]" /> Recepción de Inventario Nocturno
        </DialogTitle>
        <DialogDescription className="text-white/60">
          Tienes <span className="font-black text-[#818CF8]" data-testid="recepcion-conteo">{inventarioPatio?.conteo ?? 0}</span> vehículo(s) heredado(s) en pensión nocturna del turno anterior.
        </DialogDescription>
      </DialogHeader>
      <div className="max-h-64 overflow-y-auto border border-white/10 divide-y divide-white/10" data-testid="recepcion-lista">
        {(inventarioPatio?.folios || []).map((f) => (
          <div key={f.folio} className="flex items-center justify-between px-3 py-2 text-sm">
            <span className="font-mono text-white/80">{f.folio}</span>
            <span className="text-white/50">{f.placa || "—"}</span>
          </div>
        ))}
      </div>
      <button onClick={() => setRecepcionOpen(false)} data-testid="recepcion-confirmar-btn"
        className="btn-hard w-full h-12 bg-[#6366F1] text-white border border-[#6366F1] font-bold uppercase tracking-wider flex items-center justify-center gap-2">
        <CheckCircle2 className="h-4 w-4" /> Confirmar Recepción de Inventario
      </button>
    </DialogContent>
  </Dialog>
);

export default RecepcionInventarioDialog;
